import React, { Component } from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import { Label, Input } from 'reactstrap';
import { Link } from 'react-router-dom';

class TosModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      disableBtn: true,
      showModal: this.props.modal
    };
    this.toggleCheckbox = this.toggleCheckbox.bind(this);
    this.proceed = this.proceed.bind(this);
  }

  toggleCheckbox(e) {
    this.setState({
      disableBtn: !e.target.checked
    });
  }

  proceed() {
    this.props.onConfirm();
    this.setState((state, props) => {
      return {
        showModal: false
      };
    });
  }

  render() {
    let tosLink = (
      <Link to="/termsofuse" target="_blank">
        Terms of Use
      </Link>
    );
    if (this.props.client && this.props.client.indexOf('permitium') >= 0) {
      tosLink = (
        <Link to="/termsofuseperm" target="_blank">
          Terms of Use
        </Link>
      );
    }
    if (this.props.client && this.props.client.indexOf('archive') >= 0) {
      tosLink = (
        <Link
          to={`/termsofusearchive/${this.props.districtName}`}
          target="_blank"
        >
          Terms of Use
        </Link>
      );
    }
    return (
      <Modal isOpen={this.state.showModal}>
        <ModalBody>
          <div style={{ textAlign: 'center' }}>
            <Label check>
              <Input
                type="checkbox"
                name="accept"
                onChange={this.toggleCheckbox}
              />{' '}
              I accept the {tosLink}
            </Label>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            className="btn btn-success"
            onClick={this.proceed}
            disabled={this.state.disableBtn}
          >
            Proceed
          </button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default TosModal;
